import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { appHeaderSubMenuItemProps } from "@src/components/app-header/types";
import { DropdownItem } from "@src/pages/batches/student-batch-list/data";
interface HeaderState {
  selectedMenu: string;
  selectedSubMenu: string;
  menuDropdownList: DropdownItem[];
  orgMenuDropdownList: string[] | { label: string; value: string }[];
  selectedDropdownItem: {
    label: string;
    value: string;
    iconName: string;
    id: string;
  };
  selectedOrgDropdownItem: {
    label: string;
    value: string;
    iconName: string;
    id: string;
  };
  dropdownSubmenuItems: appHeaderSubMenuItemProps[];
  shouldHideSubmenus: boolean;
}

const initialState: HeaderState = {
  selectedMenu: "",
  selectedSubMenu: "",
  menuDropdownList: [],
  orgMenuDropdownList: [],
  selectedDropdownItem: { label: "", value: "", iconName: "", id: " " },
  selectedOrgDropdownItem: { label: "", value: "", iconName: "", id: " " },
  dropdownSubmenuItems: [],
  shouldHideSubmenus: false,
};

const headersSlice = createSlice({
  name: "headers",
  initialState,
  reducers: {
    setSelectedMenu(state, action: PayloadAction<string>) {
      state.selectedMenu = action.payload;
    },
    setSelectedSubMenu(state, action: PayloadAction<string>) {
      state.selectedSubMenu = action.payload;
    },
    setDropdownMenuList(state, action: PayloadAction<DropdownItem[]>) {
      state.menuDropdownList = action.payload;
    },
    setOrgDropdownMenuList(
      state,
      action: PayloadAction<string[] | { label: string; value: string }[]>,
    ) {
      state.orgMenuDropdownList = action.payload;
    },
    setSelectedDropdownItem(
      state,
      action: PayloadAction<{
        label: string;
        value: string;
        iconName: string;
        id: string;
        subjectId?: string;
        syllabusId?: string;
        syllabusName?: string;
        batchId?: string;
        category?: string;
        subjectName?: string;
        programmingLanguage?: any[];
      }>,
    ) {
      state.selectedDropdownItem = action.payload;
      state.shouldHideSubmenus = action.payload.label === "All Subjects";
    },
    setSelectedOrgDropdownItem(
      state,
      action: PayloadAction<{
        label: string;
        value: string;
        iconName: string;
        id: string;
      }>,
    ) {
      state.selectedOrgDropdownItem = action.payload;
      state.shouldHideSubmenus = action.payload.label === "Organizations";
    },
    setDropdownSubmenuItems(
      state,
      action: PayloadAction<appHeaderSubMenuItemProps[]>,
    ) {
      state.dropdownSubmenuItems = action.payload;
    },
    clearHeaderState: () => initialState,
  },
});

export const {
  setSelectedMenu,
  setSelectedSubMenu,
  setDropdownMenuList,
  setSelectedDropdownItem,
  setSelectedOrgDropdownItem,
  setOrgDropdownMenuList,
  setDropdownSubmenuItems,
  clearHeaderState,
} = headersSlice.actions;

export default headersSlice.reducer;
